import React from 'react';

import Tippy, { TippyProps } from '@tippyjs/react';

import { cn } from 'domain/core';

interface TooltipProps extends TippyProps {}
const Tooltip = (props: TooltipProps) => {
  const { className, ...rest } = props;

  return (
    <Tippy
      {...rest}
      className={cn(
        'tippy-tooltip',
        'bg-neutral-50 shadow-xl p-2 rounded border border-neutral-200',
        className
      )}
      arrow
      animation='scale'
    />
  );
};

Tooltip.displayName = 'Tooltip';

export { Tooltip };
